module.exports = __webpack_public_path__ + "img/banner-1.fe8ceb7e.png";